export default __webpack_public_path__ + "static/media/graph.69ec9874.svg";